// extracted by mini-css-extract-plugin
export var leftRound = "Newsletter-module--leftRound--TZjFy";
export var rightRoundNesLetter = "Newsletter-module--rightRoundNesLetter--9KxrB";